module.exports = __webpack_public_path__ + "src/assets/models/lobby_table.fbx";